export default "__VITE_ASSET__qjcDIel9__"